import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { AccordionWithButton } from 'UIPackage/MainModule/components/AccordionWithButton';

import styles from './KnmListByPlanRequirementsList.module.scss';

export const KnmListByPlanEvents = ({ row }: ITableRenderCell<IKnmRaw>) => {
  return (
    <>
      {row.events &&
        row.events.length > 0 &&
        (row.events.length > 1 ? (
          <>
            <div className={styles.MultiListTitle}>{row.events[0]?.title}</div>
            <div className={styles.MultiListDate}>{`${row.events[0]?.startDate} - ${row.events[0]?.stopDate}`}</div>
            <AccordionWithButton
              content={row.events
                .filter((item, index) => item && index > 0)
                .map(item => (
                  <>
                    <div className={styles.MultiListTitle}>{item?.title}</div>
                    <div className={styles.MultiListDate}>{`${item?.startDate} - ${item?.stopDate}`}</div>
                  </>
                ))}
            />
          </>
        ) : (
          <>
            <div className={styles.MultiListTitle}>{row.events[0]?.title}</div>
            <div className={styles.MultiListDate}>{`${row.events[0].startDate} - ${row.events[0]?.stopDate}`}</div>
          </>
        ))}
    </>
  );
};
